import { Helmet } from "react-helmet-async";

const ORG_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "NonprofitOrganization",
  name: "Tales&Legends gUG",
  legalName: "Tales&Legends gemeinnützige UG (haftungsbeschränkt)",
  // Notarized in June 2026, HRB 48120 at the Amtsgericht Dresden (see
  // Impressum). Day-level precision isn't published anywhere on the site,
  // so the month is as specific as this can honestly be.
  foundingDate: "2026-06",
  url: "https://talesandlegends.org",
  // Google looks for `telephone` at both the top level and on contactPoint —
  // real number, see Impressum/Kontakt/Info (§ finding 2, NAP consistency).
  telephone: "+49 351 8967226-0",
  // Google's logo rich-result guidance prefers raster formats (PNG/JPEG/
  // WebP) over SVG — min. 112x112px, this one's 1200x886.
  logo: "https://talesandlegends.org/assets/brand/logo-mark.png",
  sameAs: [
    "https://www.instagram.com/tales.wtf",
    "https://discord.gg/6Xw4fycXBc",
    "https://www.tiktok.com/@tales.wtf",
    "https://www.youtube.com/@tales-wtf",
    "https://www.linkedin.com/company/talesandlegends",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+49 351 8967226-0",
    email: "hello@talesandlegends.org",
    contactType: "customer support",
    areaServed: "DE",
    availableLanguage: ["de", "en"],
  },
  // Freital, not Dresden: the legally registered seat per the Impressum
  // (Reiboldschachtring 28, 01705 Freital) — this previously said "Dresden"
  // here, a real NAP inconsistency against the Impressum/Info pages that
  // undermines local-search trust and would block a future Google Business
  // Profile claim. Homepage marketing copy previously said "Dresden and
  // Saxony" as its service-area framing while the About page said "across
  // Germany ... Saxony" — inconsistent across pages, so both now standardize
  // on "Germany and Saxony" (home.heroTitle/heroSubtitle in the locale files).
  // The registered seat is Freital; the events, the team and every
  // "aus Dresden" line in the copy are about where we actually operate.
  // areaServed is the property that says that without contradicting the
  // address above.
  areaServed: [
    { "@type": "City", name: "Dresden" },
    { "@type": "AdministrativeArea", name: "Sachsen" },
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Reiboldschachtring 28",
    postalCode: "01705",
    addressLocality: "Freital",
    addressCountry: "DE",
  },
};

export default function OrganizationJsonLd() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(ORG_JSON_LD)}</script>
    </Helmet>
  );
}
